var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "search" },
    [
      _c(
        "v-row",
        {
          attrs: { horizontal: "center", variant: "flex", vertical: "center" }
        },
        [
          _c("v-column", { attrs: { large: 12 } }, [
            _vm.searchInput
              ? _c(
                  "div",
                  { staticClass: "search__head" },
                  [
                    _c("v-typo", {
                      staticClass: "search__headline",
                      attrs: { variant: "h1" },
                      domProps: { innerHTML: _vm._s(_vm.$t("search.headline")) }
                    }),
                    _vm._v(" "),
                    _c("v-typo", {
                      staticClass: "search__perex",
                      attrs: { variant: "body-perex" },
                      domProps: { innerHTML: _vm._s(_vm.$t("search.perex")) }
                    }),
                    _vm._v(" "),
                    _c("v-input", {
                      staticClass: "search__input",
                      attrs: {
                        placeholder: _vm.$t("common.input.search.placeholder"),
                        "icon-name": "ui/search"
                      },
                      model: {
                        value: _vm.searchValue,
                        callback: function($$v) {
                          _vm.searchValue = $$v
                        },
                        expression: "searchValue"
                      }
                    }),
                    _vm._v(" "),
                    _vm.searchValue.length > 2
                      ? _c("div", { staticClass: "search__dropdown" }, [
                          _c("div", { staticClass: "search__dropdown-inner" }, [
                            _vm.searchItems && _vm.searchItems.length
                              ? _c(
                                  "div",
                                  { staticClass: "search__result" },
                                  _vm._l(_vm.searchItems, function(item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "search__result-item"
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                name:
                                                  "helpDetail-" +
                                                  _vm.$i18n.locale,
                                                params: { slug: item.category },
                                                query: { section: item.section }
                                              },
                                              "data-hovered": "true"
                                            }
                                          },
                                          [
                                            _c("v-typo", {
                                              attrs: {
                                                variant: "body-paragraph"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.headline +
                                                    " | " +
                                                    item.title
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              : _c(
                                  "div",
                                  { staticClass: "search__result" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "search__result-no" },
                                      [
                                        _c("v-icon", {
                                          staticClass:
                                            "search__result-no__icon",
                                          attrs: { name: "ui/close" }
                                        }),
                                        _vm._v(" "),
                                        _c("v-typo", {
                                          staticClass: "search__result-perex",
                                          attrs: { variant: "body-paragraph" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t("help.noResult")
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("hr", {
                                      staticClass: "search__result-no__hr"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "search__result-item-title"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t("help.categoriesTitle")
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.popularCategories, function(
                                      item
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.id,
                                          staticClass: "search__result-item"
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name:
                                                    "helpDetail-" +
                                                    _vm.$i18n.locale,
                                                  params: {
                                                    slug: item.category
                                                  },
                                                  query: {
                                                    section: item.section
                                                  }
                                                },
                                                "data-hovered": "true"
                                              }
                                            },
                                            [
                                              _c("v-typo", {
                                                attrs: {
                                                  variant: "body-paragraph"
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    item.headline +
                                                      " | " +
                                                      item.title
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    })
                                  ],
                                  2
                                )
                          ])
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.articlesData
              ? _c(
                  "div",
                  { staticClass: "search__articles" },
                  [
                    _c(
                      "v-row",
                      {
                        staticClass: "search__articles-row",
                        attrs: {
                          horizontal: "start",
                          variant: "flex",
                          vertical: "start"
                        }
                      },
                      _vm._l(_vm.articlesData, function(article) {
                        return _c(
                          "v-column",
                          {
                            key: "article-id-" + article.id,
                            staticClass: "search__article",
                            attrs: { large: 4 }
                          },
                          [
                            _c("v-article-category-card", {
                              attrs: { data: article }
                            })
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }